import DeliveryRegionRoutingComponent from './delivery_region_routing.component';
import DeliveryRegionRoutingAll from './all';
import DeliveryRegionRoutingCreate from './create';
import DeliveryRegionRoutingEdit from './edit';

let DeliveryRegionRoutingModule = angular.module('deliveryRegionRouting', [
    DeliveryRegionRoutingCreate,
    DeliveryRegionRoutingAll,
    DeliveryRegionRoutingEdit
])

    .component('deliveryRegionRouting', DeliveryRegionRoutingComponent)

    .config(($stateProvider) => {
        "ngInject";

        $stateProvider
            .state('delivery-region-routing.create', {
                url: '/create',
                component: 'deliveryRegionRoutingCreate',
                data: {
                    requireACL: 'setting-delivery-region-routing.create'
                }
            })
            .state('delivery-region-routing.all', {
                url: '/all/:page',
                component: 'deliveryRegionRoutingAll',
                data: {
                    requireACL: 'setting-delivery-region-routing.view'
                }
            })
            .state('delivery-region-routing.edit/:id', {
                url: '/edit/:id',
                component: 'deliveryRegionRoutingCreate',
                data: {
                    requireACL: 'setting-delivery-region-routing.edit'
                }
            })
    })

    .name;

export default DeliveryRegionRoutingModule;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/index.js